import moment from 'moment';

export function formatTextWrap(text, maxLineLength) {
  const words = text.replace(/[\r\n]+/g, ' ').split(' ');
  let lineLength = 0;

  // use functional reduce, instead of for loop
  return words.reduce((result, word) => {
    if (lineLength + word.length >= maxLineLength) {
      lineLength = word.length;
      return result + `\n${word}`; // don't add spaces upfront
    } else {
      lineLength += word.length + (result ? 1 : 0);
      return result ? result + ` ${word}` : `${word}`; // add space only when needed
    }
  }, '');
}

export function normalizeDetail(text) {
  var replacedText = text.replaceAll("~~", " ");
  return replacedText;
}
export function splittedBetData(text) {
  let splittedText = text.split("~~");
  return splittedText;
}

export function hasRotationNumber(text) {
  return text.indexOf('[') > -1 && text.indexOf(']') > -1;
}

export function parseRotatationNumber(text) {
  var regex = /\[(.*?)\]/;
  var matches = regex.exec(text);
  if (hasRotationNumber(text)) {
    var rotWithBracket = matches[0];
    var rotWithoutBracket = matches[1];
    return {
      rotWithBracket,
      rotWithoutBracket,
    };
  }
  return {
    rotWithBracket: null,
    rotWithoutBracket: null,
  };
}

export const validations = {
  isValid(bets) {
    return (bets.attributes && bets.attributes.TransType) || bets.TransType;
  },
  isSports1(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.Result == 'LOSE' &&
      bets.attributes.HeaderDesc.substring(0, 4) !== 'Live'
    );
  },
  isSports2(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.Result == 'WIN' &&
      bets.attributes.HeaderDesc.substring(0, 4) !== 'Live'
    );
  },
  isSports3(bets) {
    return !!bets.attributes.TransType && bets.attributes.TransType == 'I' && bets.attributes.Result == 'N/A';
  },
  isSports4(bets) {
    return (
      !!bets.attributes.TransType &&
      (bets.attributes.TransType == 'I' || bets.attributes.TransType == 'W' || bets.TransType == 'W') &&
      bets.attributes.HeaderDesc.substring(0, 4) !== 'Live' &&
      bets.attributes.Result == 'WIN'
    );
  },
  isSports5(bets) {
    return (
      !!bets.attributes.TransType &&
      (bets.attributes.TransType == 'I' || bets.attributes.TransType == 'W' || bets.TransType == 'W') &&
      bets.attributes.HeaderDesc.substring(0, 4) !== 'Live' &&
      bets.attributes.Result == 'LOSE'
    );
  },
  isSports6(bets) {
    return !!bets.attributes.TransType && bets.attributes.TransType == 'W' && bets.attributes.Result == 'PUSH';
  },
  isLive1(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.HeaderDesc.substring(0, 4) == 'Live' &&
      parseFloat(winLoss) > 0
    );
  },
  isLive2(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.HeaderDesc.substring(0, 4) == 'Live' &&
      parseFloat(winLoss) < 0
    );
  },
  isLive3(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.HeaderDesc.substring(0, 11) == 'Ticket Live' &&
      bets.HeaderDesc.substring(0, 11) == 'Ticket Live'
    );
  },
  isLive4(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'W' &&
      bets.attributes.HeaderDesc.substring(0, 21) == 'Wager Won Ticket Live' &&
      bets.HeaderDesc.substring(0, 21) == 'Wager Won Ticket Live'
    );
  },
  isLive5(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'A' &&
      bets.attributes.HeaderDesc.substring(0, 22) == 'Wager Lost Ticket Live' &&
      bets.HeaderDesc.substring(0, 22) == 'Wager Lost Ticket Live'
    );
  },
  isMoney1(bets) {
    return !!bets.attributes && !!bets.attributes.TransType && bets.attributes.TransType == 'C';
  },
  isMoney2(bets) {
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'D' &&
      bets.attributes.HeaderDesc.substring(0, 16) === 'Payout Requested'
    );
  },
  isMoney3(bets) {
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'D' &&
      bets.attributes.HeaderDesc.substring(0, 18) === 'NEW PAYOUT CREATED'
    );
  },
  isMoney4(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;

    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'D' &&
      (parseFloat(winLoss) > 0 || parseFloat(winLoss) < 0 || parseFloat(winLoss) == 0)
    );
  },
  isMoney5(bets) {
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'R' &&
      bets.attributes.HeaderDesc.indexOf('Reup') !== false
    );
  },
  isMoney6(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'R' &&
      (parseFloat(winLoss) > 0 || parseFloat(winLoss) < 0 || parseFloat(winLoss) == 0)
    );
  },
  isMoney7(bets) {
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'R' &&
      bets.attributes.HeaderDesc.substring(0, 15) === 'PAYOUT MODIFIED'
    );
  },
  isMoney8(bets) {
    return !!bets.attributes && !!bets.attributes.TransType && bets.attributes.TransType == 'R';
  },
  isMoney9(bets) {
    return !!bets.attributes && !!bets.attributes.TransType && bets.attributes.TransType == 'P';
  },
  isMoney10(bets) {
    return !!bets.TransType && bets.TransType == 'W';
  },
  isMoney11(bets) {
    return (
      !!bets.attributes &&
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'A' &&
      (bets.attributes.HeaderDesc.substring(0, 9) == 'Depósito' ||
        bets.attributes.HeaderDesc.substring(0, 7) == 'Deposit' ||
        bets.attributes.HeaderDesc.substring(0, 6) == 'Retiro' ||
        bets.attributes.HeaderDesc.substring(0, 10) == 'TEST FUNDS')
    );
  },
  isRacebook1(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes && !!bets.attributes.TransType && bets.attributes.TransType == 'H' && parseFloat(winLoss) < 0
    );
  },
  isRacebook2(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes && !!bets.attributes.TransType && bets.attributes.TransType == 'H' && parseFloat(winLoss) > 0
    );
  },
  isRacebook3(bets) {
    return !!bets.TransType && bets.TransType == 'H';
  },
  isCasino1(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
        bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
        bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free') &&
      parseFloat(winLoss) > 0
    );
  },
  isCasino2(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
        bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
        bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free') &&
      parseFloat(winLoss) == 0
    );
  },
  isCasino3(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Bet' &&
      parseFloat(winLoss) < 0
    );
  },
  isCasino4(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Bet' &&
      parseFloat(winLoss) > 0
    );
  },
  isCasino5(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
        bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
        bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free')
    );
  },
  isCasino6(bets) {
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.substring(0, 9) == 'Bonus win' ||
        bets.attributes.HeaderDesc.substring(0, 9) == 'Bonus Win')
    );
  },
  isCasino7(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.indexOf('Casino Wager') ||
        bets.attributes.HeaderDesc.indexOf('Blackjack') !== false) &&
      bets.attributes.HeaderDesc.indexOf('Live Casino') === false &&
      parseFloat(winLoss) > 0
    );
  },
  isCasino8(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      (bets.attributes.HeaderDesc.indexOf('Casino Wager') ||
        bets.attributes.HeaderDesc.indexOf('Blackjack') !== false) &&
      bets.attributes.HeaderDesc.indexOf('Live Casino') === false &&
      parseFloat(winLoss) <= 0
    );
  },
  isCasino9(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      bets.attributes.TransType == 'K' &&
      bets.attributes.HeaderDesc.substring(0, 10) !== 'Casino Win' &&
      parseFloat(winLoss) < 0 &&
      bets.attributes.HeaderDesc.indexOf('Live Casino') === false
    );
  },
  isCasino10(bets) {
    return !!bets.attributes.TransType && bets.attributes.TransType == 'K' && parseFloat(bets.attributes.WinLoss) == 0;
  },
  isLiveCasino1(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      (bets.attributes.TransType == 'A' || bets.attributes.TransType == 'K') &&
      bets.attributes.HeaderDesc.substring(0, 11) == 'Live Casino' &&
      parseFloat(winLoss) < 0
    );
  },
  isLiveCasino2(bets) {
    const betWinLoss = bets.attributes ? bets.attributes.WinLoss : bets.WinLoss;
    const winLoss = betWinLoss.includes('USD') ? betWinLoss.replace('USD', '') : betWinLoss;
    return (
      !!bets.attributes.TransType &&
      (bets.attributes.TransType == 'A' || bets.attributes.TransType == 'K') &&
      bets.attributes.HeaderDesc.substring(0, 11) == 'Live Casino' &&
      parseFloat(winLoss) > 0
    );
  },
  isWinLoss(bets) {
    return this.isValid(bets);
  },
  isSportsBulk(bets) {
    if (!bets.attributes) return;
    return (
      this.isValid(bets) &&
      (this.isSports1(bets) ||
        this.isSports2(bets) ||
        this.isSports3(bets) ||
        this.isSports4(bets) ||
        this.isSports5(bets) ||
        this.isSports6(bets))
    );
  },
  isLiveBulk(bets) {
    if (!bets.attributes) return;
    return (
      this.isValid(bets) &&
      (this.isLive1(bets) || this.isLive2(bets) || this.isLive3(bets) || this.isLive4(bets) || this.isLive5(bets))
    );
  },
  isMoneyBulk(bets) {
    return (
      this.isValid(bets) &&
      (this.isMoney1(bets) ||
        this.isMoney2(bets) ||
        this.isMoney3(bets) ||
        this.isMoney4(bets) ||
        this.isMoney5(bets) ||
        this.isMoney6(bets) ||
        this.isMoney7(bets) ||
        this.isMoney8(bets) ||
        this.isMoney9(bets) ||
        this.isMoney10(bets) ||
        this.isMoney11(bets))
    );
  },
  isRacebookBulk(bets) {
    return this.isValid(bets) && (this.isRacebook1(bets) || this.isRacebook2(bets) || this.isRacebook3(bets));
  },
  isCasinoBulk(bets) {
    if (!bets.attributes) return;
    return (
      this.isValid(bets) &&
      (this.isCasino1(bets) ||
        this.isCasino2(bets) ||
        this.isCasino3(bets) ||
        this.isCasino4(bets) ||
        this.isCasino5(bets) ||
        this.isCasino6(bets) ||
        this.isCasino7(bets) ||
        this.isCasino8(bets) ||
        this.isCasino10(bets))
    );
  },
  isLiveCasinoBulk(bets) {
    if (!bets.attributes) return;
    return this.isValid(bets) && (this.isLiveCasino1(bets) || this.isLiveCasino2(bets));
  },
};

// used in open bets, history and bet lines to convert time to CT timezone
// DB stores time 1 hour ahead from CT, so decreases 1 hour to convert CT
export function convertTimeToCT(time, utcOffset) {
  return moment(time);
}

export function convertTimeToCTAndFormat(time) {
  return moment(time);
}

export function convertTimeToCTAndFormatPrint(time, locate = 'en') {
  moment.locale(locate);
  return moment(time).format('MMM DD YYYY HH:mm');
}

export function formatOpenBetsGameTime(detail) {
  const newDate = convertTimeToCTAndFormat(detail.GameDateTime);
  return newDate;
}

export function formatOpenBetsData(bets, currencySymbol) {
  return bets.map(wager => {
    if (wager.TicketNumber) wager.TicketNumber = '' + wager.TicketNumber;
    if (wager.OriginalRiskAmount !== undefined || wager.OriginalRiskAmount !== null)
      wager.OriginalRiskAmount = currencySymbol + parseFloat(wager.OriginalRiskAmount).toFixed(2);
    if (wager.OriginalWinAmount !== undefined || wager.OriginalWinAmount !== null)
      wager.OriginalWinAmount = currencySymbol + parseFloat(wager.OriginalWinAmount).toFixed(2);
    if (wager.PlacedDate) wager.PlacedDate = convertTimeToCTAndFormat(wager.PlacedDate);
    if (wager.Detail) {
      wager.Detail = wager.Detail.map(detail => {
        return {
          ...detail,
          GameDateTime: formatOpenBetsGameTime(detail),
        };
      });
    }
    return wager;
  });
}

export function defineCategory(bets) {
  // console.log(bets.attributes.HeaderDesc)
  if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'W' &&
    bets.attributes.Result == 'LOSE' &&
    bets.attributes.HeaderDesc.substring(0, 4) !== 'Live'
  ) {
    bets.category = 'Sportsbook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'W' &&
    bets.attributes.Result == 'WIN' &&
    bets.attributes.HeaderDesc.substring(0, 4) !== 'Live'
  ) {
    bets.category = 'Sportsbook';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'I' && bets.attributes.Result == 'N/A') {
    bets.category = 'Sportsbook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'W' &&
    bets.attributes.HeaderDesc.substring(0, 4) !== 'Live' &&
    parseFloat(bets.attributes.WinLoss) > 0
  ) {
    bets.category = 'Sportsbook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'W' &&
    bets.attributes.HeaderDesc.substring(0, 4) == 'Live' &&
    parseFloat(bets.attributes.WinLoss) > 0
  ) {
    bets.category = 'SportbookLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'W' &&
    bets.attributes.HeaderDesc.substring(0, 4) == 'Live' &&
    parseFloat(bets.attributes.WinLoss) < 0
  ) {
    bets.category = 'SportbookLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    (bets.attributes.TransType == 'I' || bets.attributes.TransType == 'W') &&
    bets.attributes.HeaderDesc.substring(0, 4) !== 'Live' &&
    bets.attributes.Result == 'WIN'
  ) {
    bets.category = 'Sportsbook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    (bets.attributes.TransType == 'I' || bets.attributes.TransType == 'W') &&
    bets.attributes.HeaderDesc.substring(0, 4) !== 'Live' &&
    bets.attributes.Result == 'LOSE'
  ) {
    bets.category = 'Sportsbook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'A' &&
    bets.attributes.HeaderDesc.substring(0, 11) == 'Ticket Live'
  ) {
    bets.category = 'SportbookLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'A' &&
    bets.attributes.HeaderDesc.substring(0, 21) == 'Wager Won Ticket Live'
  ) {
    bets.category = 'SportbookLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'A' &&
    bets.attributes.HeaderDesc.substring(0, 22) == 'Wager Lost Ticket Live'
  ) {
    bets.category = 'SportbookLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'H' &&
    parseFloat(bets.attributes.WinLoss) < 0
  ) {
    bets.category = 'Racebook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'H' &&
    parseFloat(bets.attributes.WinLoss) > 0
  ) {
    bets.category = 'Racebook';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'H') {
    bets.category = 'Racebook';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'C') {
    bets.category = 'Money';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'D' &&
    bets.attributes.HeaderDesc.substring(0, 16) === 'Payout Requested'
  ) {
    bets.category = 'Money';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'D' &&
    bets.attributes.HeaderDesc.substring(0, 18) === 'NEW PAYOUT CREATED'
  ) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'D' && bets.attributes.WinLoss > 0) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'D' && bets.attributes.WinLoss < 0) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'D' && bets.attributes.WinLoss == 0) {
    bets.category = 'Money';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'R' &&
    bets.attributes.HeaderDesc.indexOf('Reup') !== false
  ) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'R' && bets.attributes.WinLoss > 0) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'R' && bets.attributes.WinLoss < 0) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'R' && bets.attributes.WinLoss == 0) {
    bets.category = 'Money';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'R' &&
    bets.attributes.HeaderDesc.substring(0, 15) == 'PAYOUT MODIFIED'
  ) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'R') {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'P') {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.TransType && bets.TransType == 'W') {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.TransType && bets.TransType == 'H') {
    bets.category = 'Racebook';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
      bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
      (bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free' && parseFloat(bets.attributes.WinLoss) > 0))
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
      bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
      (bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free' && parseFloat(bets.attributes.WinLoss) == 0))
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Bet' &&
    parseFloat(bets.attributes.WinLoss) < 0
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Bet' && parseFloat(bets.attributes.WinLoss) > 0)
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 10) == 'Casino Win' ||
      bets.attributes.HeaderDesc.substring(0, 10) == 'Casino win' ||
      bets.attributes.HeaderDesc.substring(0, 11) == 'Casino free')
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 9) == 'Bonus win' ||
      bets.attributes.HeaderDesc.substring(0, 9) == 'Bonus Win')
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    ((bets.attributes.HeaderDesc.indexOf('Casino Wager') ||
      bets.attributes.HeaderDesc.indexOf('Blackjack') !== false) &&
      bets.attributes.HeaderDesc.indexOf('Live Casino') === false) &&
    parseFloat(bets.attributes.WinLoss) > 0
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    ((bets.attributes.HeaderDesc.indexOf('Casino Wager') ||
      bets.attributes.HeaderDesc.indexOf('Blackjack') !== false) &&
      bets.attributes.HeaderDesc.indexOf('Live Casino') === false) &&
    parseFloat(bets.attributes.WinLoss) <= 0
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    (bets.attributes.HeaderDesc.substring(0, 10) !== 'Casino Win' && parseFloat(bets.attributes.WinLoss) < 0) &&
    bets.attributes.HeaderDesc.indexOf('Live Casino') === false
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'K' &&
    parseFloat(bets.attributes.WinLoss) == 0
  ) {
    bets.category = 'Casino';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    (bets.attributes.TransType == 'A' || bets.attributes.TransType == 'K') &&
    bets.attributes.HeaderDesc.substring(0, 11) == 'Live Casino' &&
    parseFloat(bets.attributes.WinLoss) < 0
  ) {
    bets.category = 'CasinoLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    (bets.attributes.TransType == 'A' || bets.attributes.TransType == 'K') &&
    bets.attributes.HeaderDesc.substring(0, 11) == 'Live Casino' &&
    parseFloat(bets.attributes.WinLoss) > 0
  ) {
    bets.category = 'CasinoLive';
    return bets;
  } else if (
    !!bets.attributes.TransType &&
    bets.attributes.TransType == 'A' &&
    (bets.attributes.HeaderDesc.substring(0, 9) == 'Depósito' ||
      bets.attributes.HeaderDesc.substring(0, 7) == 'Deposit' ||
      bets.attributes.HeaderDesc.substring(0, 6) == 'Retiro' ||
      bets.attributes.HeaderDesc.substring(0, 10) == 'TEST FUNDS')
  ) {
    bets.category = 'Money';
    return bets;
  } else if (!!bets.attributes.TransType && bets.attributes.TransType == 'W' && bets.attributes.Result == 'PUSH') {
    bets.category = 'Sportsbook';
    return bets;
  } else {
    bets.category = 'Sportsbook';
    return bets;
  }
}
